import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ProductVariantsFinder from "@/components/ProductSelector/ProductVariantsFinder.vue";
import ModeTypeSelect from "@/components/ProductSelector/ModeTypeSelect.vue";
import ProductCategorySelector from "@/components/ProductSelector/ProductCategorySelector.vue";
import { CategoryOption } from "@/models/Option";

declare const window: any;
@Component({
    components: {
        ProductVariantsFinder,
        ModeTypeSelect,
        ProductCategorySelector
    }
  })
export default class ProductSelector extends Vue {
    @Prop() private queryUrl!: string;
    @Prop() private language!: string;

    public store = this.$store.direct;

    public config: any = {};

  public created() {
    this.store.dispatch.appStateModule.setLanguage({ language: this.language })

    // configure profuct filters and fields
    const categories = window["PRODUCT_SELECTOR_CATEGORIES"] as CategoryOption[];
    if(categories) {
      this.store.dispatch.selectorStateModule.initCategories({ categoriesConfig: categories });
    }
    const cfg = window["PRODUCT_SELECTOR_CONFIG"] as Array<any>;
    if(cfg != undefined) {
        this.store.dispatch.selectorStateModule.initConfig({config: cfg});
        this.config = this.store.getters.selectorStateModule.getSelectedConfig;
    }
  }

  @Watch('store.state.selectorStateModule.config')
  public onInitConfig() {
    const brand = this.store.getters.selectorStateModule.getSelectedConfig.Brand;
    this.store.dispatch.appStateModule.setBrand(brand);
  }

  @Watch('store.state.selectorStateModule.selectedConfigIndex')
  public onSelectedIndexChange() {
    this.config = this.store.getters.selectorStateModule.getSelectedConfig;
  }

  public onModeChange(index: number) {
    this.store.dispatch.selectorStateModule.selectConfig({ index });
  }

  public onTypeSelect(type: string) {
    this.store.commit.selectorStateModule.TOGGLE_SELECTED_TYPE(type);
  }

  public get getAvailableTypes() {
    return this.store.state.selectorStateModule.availableTypes;
  }

  public get TableVariant() {
    const cfg = this.store.state.selectorStateModule.config;
    if(Array.isArray(cfg) && (cfg.length > 1 || (cfg.length == 1 && cfg[0].Mode != null))) {
      return 'matrix';
    }
    else return 'table'
  }
}
